var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2, _initialiseProps;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { isFunction, isUndefined, throttle } from 'lodash';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

var CoreSlider = (_temp2 = _class = function (_Component) {
  _inherits(CoreSlider, _Component);

  function CoreSlider() {
    var _temp, _this, _ret;

    _classCallCheck(this, CoreSlider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  return CoreSlider;
}(Component), _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    position: undefined,
    value: this.props.value
  };

  this.componentWillReceiveProps = function (nextProps) {
    var value = nextProps.value;

    if (value && value !== _this2.state.value) {
      _this2.setState({ value: value }, _this2.updateHandle);
    }
  };

  this.componentDidMount = function () {
    _this2.updateTrack();
    _this2.updateTrack = throttle(_this2.updateTrack, 100, { leading: false });
    window.addEventListener('resize', _this2.updateTrack);
  };

  this.componentWillUnmount = function () {
    window.removeEventListener('resize', _this2.updateTrack);
  };

  this.updateTrack = function () {
    var track = ReactDOM.findDOMNode(_this2.refs.track);
    if (track) {
      var width = track.offsetWidth;
      _this2.setState({ width: width }, _this2.updateHandle);
    }
  };

  this.updateHandle = function () {
    var props = _this2.props;
    var value = _this2.state.value;


    var numer = value - props.min;
    var denom = props.max - props.min;
    _this2.setState({
      position: _this2.state.width * numer / denom
    });
  };

  this.roundToNearest = function (position) {
    if (_this2.props.max === _this2.props.min) {
      return {
        position: _this2.state.width / 2,
        value: _this2.props.min
      };
    }

    var multiplier = 1000;
    var unrounded = position / _this2.state.width * multiplier;
    var stepSize = multiplier / (_this2.props.max - _this2.props.min);
    var left = Math.floor(unrounded / stepSize);
    var right = left + 1;

    var errorLeft = unrounded - left * stepSize;
    var errorRight = right * stepSize - unrounded;
    var best = errorLeft <= errorRight ? left : right;

    return {
      position: _this2.state.width * (best * stepSize / multiplier),
      value: _this2.props.min + best
    };
  };

  this.cumulativeOffset = function (element) {
    var left = 0;
    var top = 0;

    do {
      top += element.offsetTop || 0;
      left += element.offsetLeft || 0;
      element = element.offsetParent;
    } while (element);

    return { left: left, top: top };
  };

  this.triggerOnChange = function (position) {
    var rounded = _this2.roundToNearest(position);
    _this2.setState(rounded);

    if (isFunction(_this2.props.onChange)) {
      var value = rounded.value,
          _position = rounded.position;

      _this2.props.onChange(value, _position);
    }
  };

  this.handleTrackClick = function (event) {
    var abs = _this2.cumulativeOffset(event.target).left;
    var position = event.clientX - abs;
    _this2.triggerOnChange(position);
  };

  this.handleDragStop = function (event, ui) {
    var position = _this2.refs.drag.state.x || 0;
    _this2.triggerOnChange(position);
  };

  this.handleDrag = function (event, ui) {
    var position = _this2.refs.drag.state.x || 0;
    _this2.triggerOnChange(position);
    event.preventDefault();
  };

  this.style = function (value) {
    var step = 100 / (_this2.props.max - _this2.props.min);
    return {
      left: step * (value - _this2.props.min) + '%'
    };
  };

  this.renderTicks = function () {
    if (!_this2.props.ticks) return null;

    var _props = _this2.props,
        min = _props.min,
        max = _props.max;

    var elements = [];

    if (max - min < 200) {
      for (var i = min + 1; i < max; i++) {
        var args = {
          className: 'slider__tick',
          style: _this2.style(i)
        };

        elements.push(React.createElement('span', _extends({ key: 'tick' + i }, args)));
      }
    }

    return React.createElement(
      'div',
      { className: 'slider__ticks', onClick: _this2.handleTrackClick },
      elements
    );
  };

  this.renderMarkers = function () {
    if (!_this2.props.markerLabel) return null;

    var _props2 = _this2.props,
        min = _props2.min,
        max = _props2.max,
        markers = _props2.markerLabel;

    var elements = [];

    for (var i = 0; i < markers.length; i++) {
      if (markers[i].value < min || markers[i].value > max) {
        continue;
      }

      var tick = React.createElement('span', { className: 'slider__tick slider__tick--marker' });
      if (_this2.props.ticks && max - min < 200) {
        // Only render tick if we're not also rendering ticks otherwise
        tick = null;
      }

      var args = {
        className: 'slider__marker marker',
        style: _this2.style(markers[i].value)
      };

      elements.push(React.createElement(
        'div',
        _extends({ key: 'marker-' + i }, args),
        React.createElement(
          'p',
          { className: 'marker__label' },
          markers[i].label
        ),
        tick
      ));
    }

    return React.createElement(
      'div',
      { className: 'slider__markers', onClick: _this2.handleTrackClick },
      elements
    );
  };

  this.draggable = function () {
    return !isUndefined(_this2.state.position) && React.createElement(
      Draggable,
      {
        axis: 'x',
        bounds: { left: 0, right: _this2.state.width },
        handle: '.slider__handle',
        position: { x: _this2.state.position, y: 0 },
        ref: 'drag',
        onDrag: _this2.handleDrag,
        onStop: _this2.handleDragStop
      },
      React.createElement('span', { className: 'slider__handle' })
    );
  };

  this.render = function () {
    return React.createElement(
      'div',
      { className: 'slider', ref: 'slider' },
      _this2.draggable(),
      React.createElement(
        'div',
        {
          className: 'slider__track',
          ref: 'track',
          onClick: _this2.handleTrackClick
        },
        _this2.renderTicks(),
        _this2.renderMarkers()
      )
    );
  };
}, _temp2);


CoreSlider.defaultProps = {
  max: 10,
  min: 0,
  ticks: false,
  value: 0
};

CoreSlider.propTypes = process.env.NODE_ENV !== "production" ? {
  markerLabel: PropTypes.array,
  max: PropTypes.number,
  min: PropTypes.number,
  onChange: PropTypes.func,
  ticks: PropTypes.bool,
  value: PropTypes.number
} : {};

export default CoreSlider;


//////////////////
// WEBPACK FOOTER
// ./node_modules/bodyspec-react-slider/es/core.js
// module id = 579
// module chunks = 0